// @ts-ignore
import pkg from '../../package.json' assert { type: 'json' }
const PROD = 'production-us-east-1'
export const production = pkg.deployment.properties[PROD].env
export const internal = pkg?.deployment?.properties[PROD]['internal-env']
export const external = pkg?.deployment?.properties[PROD]['external-env']
